import BaseService from '@/services/base_service';
import { clearPhone } from '@/services/string';
import Axios from 'axios';

export default class PetsService extends BaseService {

  async list(params, idCliente) {
    try {
      return await axios.get('/clientes/' + idCliente + '/pet', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id, idCliente) {
    try {
      return await axios.get('/clientes/' + idCliente + '/pet/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model, idCliente) {

    try {
      return await axios.post('clientes/' + idCliente + '/pet/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, idCliente, id) {
    try {
      return await axios.put('/clientes/' + idCliente + '/pet/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/pet/' + id);
    } catch (e) {
      throw e;
    }
  }


}



// WEBPACK FOOTER //
// ./src/services/pets.js